import React from 'react';

import { Typography } from '../../designComponents';
import { Container, HeroWrapperStyled } from './style';

type Props = {};

const Hero = (_props: Props) => {
  return (
    <HeroWrapperStyled>
      <Container>
        <Typography size={32} className="hero-title">
          <span style={{ color: '#1D8960' }}>Connect With Us</span> for
          Inquiries, Assistance, or Collaboration Opportunities
        </Typography>
        <Typography className="content">
          Connect with us for any inquiries, assistance, or collaboration
          opportunities. Our team is here to assist you with any questions or
          concerns you may have. Reach out to us using the contact information
          provided below, and we'll be happy to assist you.
        </Typography>
      </Container>
    </HeroWrapperStyled>
  );
};

export default Hero;
